// SiteUp (G6 / IF4-C): persistência local de "adiar" e "ignorar" por waha_lid.
// Backend de reviews (tabela/JSONB) ficou de fora desta fatia — sem migração.
// Chave por conta; expira snooze no client. Não envia nada ao servidor.

const STORAGE_PREFIX = 'siteup:waha_lid_reviews:account:';
export const SNOOZE_DAYS = 7;

const storageKey = accountId => `${STORAGE_PREFIX}${accountId}`;

const readAll = accountId => {
  if (!accountId || typeof localStorage === 'undefined') return {};
  try {
    const raw = localStorage.getItem(storageKey(accountId));
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

const writeAll = (accountId, data) => {
  if (!accountId || typeof localStorage === 'undefined') return;
  try {
    localStorage.setItem(storageKey(accountId), JSON.stringify(data));
  } catch {
    // quota / private mode — falha silenciosa; UI continua na sessão
  }
};

export const getReviewEntry = (accountId, lid) => {
  if (!lid) return null;
  const entry = readAll(accountId)[lid];
  if (!entry || typeof entry !== 'object') return null;

  if (entry.status === 'snoozed') {
    const until = Number(entry.snoozed_until) || 0;
    if (until && until <= Date.now()) {
      // Snooze expirou — some da lista e vira pendente de novo.
      const all = readAll(accountId);
      delete all[lid];
      writeAll(accountId, all);
      return null;
    }
  }

  return entry;
};

export const setReviewStatus = (accountId, lid, status) => {
  if (!accountId || !lid) return;
  const all = readAll(accountId);
  if (status === 'pending') {
    delete all[lid];
  } else if (status === 'snoozed') {
    all[lid] = {
      status: 'snoozed',
      snoozed_until: Date.now() + SNOOZE_DAYS * 24 * 60 * 60 * 1000,
      updated_at: Date.now(),
    };
  } else if (status === 'ignored') {
    all[lid] = {
      status: 'ignored',
      updated_at: Date.now(),
    };
  }
  writeAll(accountId, all);
};

export const clearReview = (accountId, lid) => {
  setReviewStatus(accountId, lid, 'pending');
};

export const resolveTabForLid = (accountId, lid) => {
  const entry = getReviewEntry(accountId, lid);
  if (!entry) return 'pending';
  if (entry.status === 'snoozed') return 'snoozed';
  if (entry.status === 'ignored') return 'ignored';
  return 'pending';
};
